import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=41df85c0&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41df85c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41df85c0')) {
      api.createRecord('41df85c0', component.options)
    } else {
      api.reload('41df85c0', component.options)
    }
    module.hot.accept("./RootView.vue?vue&type=template&id=41df85c0&scoped=true", function () {
      api.rerender('41df85c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mprofiles/RootView.vue"
export default component.exports